var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5635 13.962C15.7463 13.962 17.5222 12.1886 17.5222 10.0086C17.5222 7.82579 15.7463 6.04998 13.5635 6.04998C11.3807 6.04998 9.60479 7.82579 9.60479 10.0086C9.60479 12.1886 11.3807 13.962 13.5635 13.962ZM13.5635 7.02498C15.2086 7.02498 16.5472 8.36357 16.5472 10.0086C16.5472 11.6508 15.2087 12.987 13.5635 12.987C11.9183 12.987 10.5798 11.6508 10.5798 10.0086C10.5798 8.36357 11.9184 7.02498 13.5635 7.02498Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7623 11.1799L12.7623 11.1799L12.0174 10.4347C12.0174 10.4347 12.0174 10.4347 12.0174 10.4347C11.827 10.2443 11.8269 9.93553 12.0174 9.74531L12.7623 11.1799ZM12.7623 11.1799C12.8537 11.2713 12.9777 11.3226 13.107 11.3226C13.2362 11.3226 13.3602 11.2713 13.4516 11.1799L15.1098 9.52169C15.3002 9.33126 15.3002 9.02275 15.1098 8.83232C14.9194 8.6419 14.6109 8.6419 14.4204 8.83232L12.7623 11.1799Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 9.06404H30.1075C30.3768 9.06404 30.595 8.84577 30.595 8.57654C30.595 8.30731 30.3768 8.08904 30.1075 8.08904H19.7793C19.5101 8.08904 19.2918 8.30731 19.2918 8.57654C19.2918 8.84577 19.5101 9.06404 19.7793 9.06404Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 11.9229H26.5029C26.7721 11.9229 26.9904 11.7047 26.9904 11.4354C26.9904 11.1662 26.7721 10.9479 26.5029 10.9479H19.7793C19.5101 10.9479 19.2918 11.1662 19.2918 11.4354C19.2918 11.7046 19.5101 11.9229 19.7793 11.9229Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5634 24.0561C15.7462 24.0561 17.5221 22.2827 17.5221 20.1025C17.5221 17.9197 15.7463 16.1438 13.5634 16.1438C11.3806 16.1438 9.60479 17.9197 9.60479 20.1025C9.60473 22.2827 11.3806 24.0561 13.5634 24.0561ZM13.5634 17.1189C15.2085 17.1189 16.5471 18.4575 16.5471 20.1026C16.5471 21.7447 15.2086 23.0811 13.5634 23.0811C11.9183 23.0811 10.5798 21.7448 10.5798 20.1026C10.5797 18.4575 11.9184 17.1189 13.5634 17.1189Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7623 21.2737C12.8575 21.3689 12.9824 21.4166 13.107 21.4166C13.2317 21.4166 13.3565 21.3689 13.4516 21.2737L15.1098 19.6156C15.3002 19.4251 15.3002 19.1166 15.1098 18.9262C14.9194 18.7358 14.6109 18.7358 14.4204 18.9262L13.107 20.2397L12.7067 19.8394C12.5163 19.649 12.2078 19.649 12.0174 19.8394C11.827 20.0298 11.827 20.3384 12.0174 20.5288L12.7623 21.2737Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 19.1579H30.1075C30.3768 19.1579 30.595 18.9396 30.595 18.6704C30.595 18.4012 30.3768 18.1829 30.1075 18.1829H19.7793C19.5101 18.1829 19.2918 18.4012 19.2918 18.6704C19.2918 18.9396 19.5101 19.1579 19.7793 19.1579Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 22.017H26.5029C26.7721 22.017 26.9904 21.7988 26.9904 21.5295C26.9904 21.2603 26.7721 21.042 26.5029 21.042H19.7793C19.5101 21.042 19.2918 21.2603 19.2918 21.5295C19.2918 21.7988 19.5101 22.017 19.7793 22.017Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5634 34.15C15.7462 34.15 17.5221 32.3766 17.5221 30.1966C17.5221 28.0138 15.7463 26.238 13.5634 26.238C11.3806 26.238 9.60479 28.0138 9.60479 30.1966C9.60473 32.3766 11.3806 34.15 13.5634 34.15ZM13.5634 27.213C15.2085 27.213 16.5471 28.5516 16.5471 30.1966C16.5471 31.8388 15.2086 33.175 13.5634 33.175C11.9183 33.175 10.5798 31.8388 10.5798 30.1966C10.5797 28.5516 11.9184 27.213 13.5634 27.213Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.107 30.3336L12.7067 29.9334C12.5163 29.743 12.2078 29.743 12.0174 29.9334C11.827 30.1238 11.827 30.4323 12.0174 30.6228L12.0174 30.6228L12.7623 31.3677C12.8575 31.4629 12.9824 31.5105 13.107 31.5105C13.2317 31.5105 13.3565 31.4629 13.4516 31.3677L15.1098 29.7096C15.3002 29.5191 15.3002 29.2106 15.1098 29.0202C14.9194 28.8298 14.6109 28.8298 14.4204 29.0202L13.107 30.3336Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 29.252H30.1075C30.3768 29.252 30.595 29.0338 30.595 28.7645C30.595 28.4953 30.3768 28.277 30.1075 28.277H19.7793C19.5101 28.277 19.2918 28.4953 19.2918 28.7645C19.2918 29.0338 19.5101 29.252 19.7793 29.252Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7793 32.1109H26.5029C26.7721 32.1109 26.9904 31.8926 26.9904 31.6234C26.9904 31.3542 26.7721 31.1359 26.5029 31.1359H19.7793C19.5101 31.1359 19.2918 31.3542 19.2918 31.6234C19.2918 31.8926 19.5101 32.1109 19.7793 32.1109Z",
    fill: "#02B7E2",
    stroke: "#02B7E2",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetUp);
export default __webpack_public_path__ + "static/media/setUp.2e947e7468d4acb132a2ad8b396caeb9.svg";
export { ForwardRef as ReactComponent };